import React from 'react'
import {
    Route,
    withRouter
} from 'react-router-dom'
import {
  connect,
} from 'react-redux';
import AdminDeniedComponent from './AdminDeniedComponent'
import UserLoggedOutComponent from './UserLoggedOutComponent';

class PrivateAdminRoute extends React.Component {

  render() {
    const { component: Component, loggedIn, user_inactive, user, checkedLogin, ...rest } = this.props
    return (
      <Route
        {...rest}
        render={props => {
          let element = null;
          if (checkedLogin) {
            if (loggedIn && user.admin) {
              element = <Component {...props} />;
            } else if (user_inactive && !loggedIn) {
              element = <UserLoggedOutComponent />;
            } else {
              element = <AdminDeniedComponent />;
            }
          } else if (props.match.path === '/admin') {
            element = <div>Checking authorization...</div>;
          }
          return element;
        }}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    loggedIn: state.write_class.loggedIn,
    user_inactive: state.write_class.user_inactive,
    user: state.write_class.user,
    checkedLogin: state.write_class.checkedLogin
  }
}

export default withRouter(connect(mapStateToProps)(PrivateAdminRoute))



// WEBPACK FOOTER //
// ./src/components/PrivateAdminRoute.js